// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2tcLI","image":"Header_image__1I5ZI","name":"Header_name__1ULmW","info":"Header_info__3EZjX","infoRow":"Header_infoRow__2AKMg"};